// import socketIOClient from 'socket.io-client';
// const id = JSON.parse(localStorage.getItem('access'))?.employee_id;
// const token = JSON.parse(localStorage.getItem('token'))?.access_token;

export const currencyList = [
  { label: 'MYR', value: 'MYR' },
  { label: 'USD', value: 'USD' },
  { label: 'IDR', value: 'IDR' },
  { label: 'JPY', value: 'JPY' },
  { label: 'CYN', value: 'CYN' },
];

export const semesterList = [
  {
    label: 'Semester 1',
    value: 'Semester 1',
  },
  {
    label: 'Semester 2',
    value: 'Semester 2',
  },
  {
    label: 'Semester 3',
    value: 'Semester 3',
  },
  {
    label: 'Semester 4',
    value: 'Semester 4',
  },
  {
    label: 'Semester 5',
    value: 'Semester 5',
  },
  {
    label: 'Semester 6',
    value: 'Semester 6',
  },
  {
    label: 'Semester 7',
    value: 'Semester 7',
  },
  {
    label: 'Semester 8',
    value: 'Semester 8',
  },
];

export const periodList = [
  {
    label: 'Year 1 - Semester 1',
    value: 'Year 1 - Semester 1',
  },
  {
    label: 'Year 1 - Semester 2',
    value: 'Year 1 - Semester 2',
  },
  {
    label: 'Year 2 - Semester 1',
    value: 'Year 2 - Semester 1',
  },
  {
    label: 'Year 2 - Semester 2',
    value: 'Year 2 - Semester 2',
  },
  {
    label: 'Year 3 - Semester 1',
    value: 'Year 3 - Semester 1',
  },
  {
    label: 'Year 3 - Semester 2',
    value: 'Year 3 - Semester 2',
  },
];

export const typeList = [
  { label: 'Compulsory', value: 'Compulsory' },
  { label: 'Standard', value: 'Standard' },
];

export const numberList = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
];

export const learningMode = [
  { label: 'Conventional', value: 'physical' },
  { label: 'Online', value: 'online' },
];

export const learningModes = [
  { label: 'Conventional', value: 'Conventional' },
  { label: 'Online', value: 'Online' },
];

export const classroomType = [
  { label: 'Classroom', value: 'Classroom' },
  { label: 'Laboratory', value: 'laboratory' },
  { label: 'Studio', value: 'studio' },
  { label: 'Workshop', value: 'workshop' },
  { label: 'Lecture Hall', value: 'lecture hall' },
];

export const classroomTypes = [
  { label: 'Classroom', value: 'Classroom' },
  { label: 'Laboratory', value: 'Laboratory' },
  { label: 'Studio', value: 'Studio' },
  { label: 'Workshop', value: 'Workshop' },
  { label: 'Lecture Hall', value: 'Lecture Hall' },
];

export const weightage = [
  { label: '5%', value: '5%' },
  { label: '10%', value: '10%' },
  { label: '20%', value: '20%' },
  { label: '30%', value: '30%' },
  { label: '40%', value: '40%' },
  { label: '50%', value: '50%' },
];

export const outlineType = [
  { label: 'Assignment 1', value: 'Assignment 1' },
  { label: 'Assignment 2', value: 'Assignment 2' },
  { label: 'Assignment 3', value: 'Assignment 3' },
  { label: 'Assignment 4', value: 'Assignment 4' },
  { label: 'Assignment 5', value: 'Assignment 5' },
  { label: 'Assignment 6', value: 'Assignment 6' },
  { label: 'Assignment 7', value: 'Assignment 7' },
  { label: 'Assignment 8', value: 'Assignment 8' },
  { label: 'Assignment 9', value: 'Assignment 9' },
  { label: 'Assignment 10', value: 'Assignment 10' },
  { label: 'Quiz 1', value: 'Quiz 1' },
  { label: 'Quiz 2', value: 'Quiz 2' },
  { label: 'Quiz 3', value: 'Quiz 3' },
  { label: 'Quiz 4', value: 'Quiz 4' },
  { label: 'Quiz 5', value: 'Quiz 5' },
  { label: 'Quiz 6', value: 'Quiz 6' },
  { label: 'Quiz 7', value: 'Quiz 7' },
  { label: 'Quiz 8', value: 'Quiz 8' },
  { label: 'Quiz 9', value: 'Quiz 9' },
  { label: 'Quiz 10', value: 'Quiz 10' },
  { label: 'Midterm Exam', value: 'Midterm Exam' },
  { label: 'Final Exam', value: 'Final Exam' },
];

export const materialType = [
  { label: 'Assignment', value: 'Assignment' },
  { label: 'Lecture', value: 'Lecture' },
  { label: 'Quiz', value: 'Quiz' },
  { label: 'Exam', value: 'Exam' },
];

export const termTear = [
  { label: '2020', value: '2020' },
  { label: '2021', value: '2021' },
  { label: '2022', value: '2022' },
];

export const BreakingPoint = {
  HDPLUS: '(min-width: 1500px)',
  IPADPRO: '(max-width: 1200px)',
  IPAD: '(max-width: 992px)',
};

export const titleList = [
  { value: 'Mr', label: 'Mr.' },
  { value: 'Ms', label: 'Ms.' },
  { value: 'Mrs', label: 'Mrs.' },
];

export const complaintTypeList = [
  { label: 'All Complaint Type', value: '' },
  { label: 'Academic', value: 'Academic' },
  { label: 'Finance', value: 'Finance' },
  { label: 'Facilities & Services', value: 'Facilities & Services' },
  { label: 'Visa & Passport', value: 'Visa & Passport' },
  { label: 'Accommodation', value: 'Accommodation' },
  { label: 'Others', value: 'Others' },
];

export const timeTableCategory = [
  { label: 'All', value: '' },
  { label: 'Programme', value: 'Programme' },
  { label: 'Faculty', value: 'Faculty' },
  { label: 'Day', value: 'Day' },
  { label: 'Classroom', value: 'Classroom' },
  { label: 'Block', value: 'Block' },
  { label: 'Level', value: 'Level' },
];

export const weekList = [
  { label: 'Week 1', value: 'Week 1' },
  { label: 'Week 2', value: 'Week 2' },
  { label: 'Week 3', value: 'Week 3' },
  { label: 'Week 4', value: 'Week 4' },
  { label: 'Week 5', value: 'Week 5' },
  { label: 'Week 6', value: 'Week 6' },
  { label: 'Week 7', value: 'Week 7' },
  { label: 'Week 8', value: 'Week 8' },
  { label: 'Week 9', value: 'Week 9' },
  { label: 'Week 10', value: 'Week 10' },
  { label: 'Week 11', value: 'Week 11' },
  { label: 'Week 12', value: 'Week 12' },
  { label: 'Week 13', value: 'Week 13' },
  { label: 'Week 14', value: 'Week 14' },
  { label: 'Week 15', value: 'Week 15' },
  { label: 'Week 16', value: 'Week 16' },
  { label: 'Week 17', value: 'Week 17' },
  { label: 'Week 18', value: 'Week 18' },
  { label: 'Week 19', value: 'Week 19' },
  { label: 'Week 20', value: 'Week 20' },
];

export const studentType = [
  { label: 'New student', value: 'New student' },
  { label: 'Alumni student', value: 'Alumni student' },
];

export const academicDuration = [
  { label: 'Whole duration', value: 'Whole duration' },
  { label: '1st Semester only', value: '1st Semester only' },
  { label: '1st Year only', value: '1st Year only' },
  { label: 'Foundation only', value: 'Foundation only' },
  { label: 'Renewal only', value: 'Renewal only' },
];

export const renewalDuration = [
  { label: 'GPA >3.0', value: 'GPA > 3.0' },
  { label: 'CGPA >3.0', value: 'CGPA >3.0' },
  { label: 'CGPA >3.0 and Attendance > 80%', value: 'CGPA >3.0 and Attendance > 80%' },
  { label: 'Auto Renew', value: 'Auto Renew' },
  { label: 'Not Renewal', value: 'Not Renewal' },
];

export const scholarPercent = [
  { label: '10% Scholarship', value: '10' },
  { label: '20% Scholarship', value: '20' },
  { label: '25% Scholarship', value: '25' },
  { label: '30% Scholarship', value: '30' },
  { label: '40% Scholarship', value: '40' },
  { label: '50% Scholarship', value: '50' },
  { label: '60% Scholarship', value: '60' },
  { label: '70% Scholarship', value: '70' },
  { label: '75% Scholarship', value: '75' },
  { label: '80% Scholarship', value: '80' },
  { label: '90% Scholarship', value: '90' },
  { label: '100% Scholarship', value: '100' },
];

export const transNature = [
  {
    label: 'Income',
    value: 'Income',
  },
  {
    label: 'Expense',
    value: 'Expense',
  },
];

export const transType = [
  {
    label: 'Credit card',
    value: 'Credit card',
  },
  {
    label: 'Online transfer',
    value: 'Online transfer',
  },
  {
    label: 'Telegraphic transfer (TT)',
    value: 'Telegraphic transfer (TT)',
  },
  {
    label: 'Cheque',
    value: 'Cheque',
  },
  {
    label: 'ATM transfer',
    value: 'ATM transfer',
  },
];

export const categoryList = [
  {
    label: 'Student Outstanding',
    value: 'Student Outstanding',
  },
  {
    label: 'Applicant Outstanding',
    value: 'Applicant Outstanding',
  },
  {
    label: 'Agent Outstanding',
    value: 'Agent Outstanding',
  },
  {
    label: 'Grant Payment',
    value: 'Grant Payment',
  },
  {
    label: 'Scholarship Payment',
    value: 'Scholarship Payment',
  },
];

export const categoryList2 = [
  {
    label: 'Student Outstanding',
    value: 'Student Outstanding',
  },
  {
    label: 'Applicant Outstanding',
    value: 'Applicant Outstanding',
  },
  {
    label: 'Agent Outstanding',
    value: 'Agent Outstanding',
  },
];

export const grantSourceList = [
  { label: 'Government', value: 'Government' },
  { label: 'Private', value: 'Private' },
];

export const grantDurationList = [
  { label: '6 Months', value: '6 Months' },
  { label: '12 Months', value: '12 Months' },
];

export const approveOption = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Verified', value: 'Verified' },
  { label: 'Rejected', value: 'Rejected' },
];

export const feeCategory = [
  { label: 'Apartment Change Room Fee', value: 'Apartment Change Room Fee' },
  { label: 'Apartment Overstay', value: 'Apartment Overstay' },
  { label: 'Apartment Rental', value: 'Apartment Rental' },
  { label: 'Apartment Rental Deposit', value: 'Apartment Rental Deposit' },
  { label: 'Add/Drop courses admin charges', value: 'Add/Drop courses admin charges' },
  { label: 'Assessment Appeal admin charges', value: 'Assessment Appeal admin charges' },
  { label: 'Admin fee', value: 'Admin fee' },
  { label: 'Certificate', value: 'Certificate' },
  { label: 'Convocation Fees', value: 'Convocation Fees' },
  { label: 'Courier Service', value: 'Courier Service' },
  { label: 'Deferment Charge', value: 'Deferment Charge' },
  { label: 'Gown Late Return Penalty', value: 'Gown Late Return Penalty' },
  { label: 'Graduation Invited Guests', value: 'Graduation Invited Guests' },
  { label: 'Gown deposit', value: 'Gown deposit' },
  { label: 'Gown Only', value: 'Gown Only' },
  { label: 'IELTS Book Fees', value: 'IELTS Book Fees' },
  { label: 'IELTS Exam Fees', value: 'IELTS Exam Fees' },
  { label: 'IELTS Resource Fee', value: 'IELTS Resource Fee' },
  { label: 'IH Immersion Fees', value: 'IH Immersion Fees' },
  { label: 'Late payment penalty', value: 'Late payment penalty' },
  { label: 'International Admin', value: 'International Admin' },
  { label: 'Late Registration Admin Fee', value: 'Late Registration Admin Fee' },
  { label: 'Library Fine', value: 'Library Fine' },
  { label: 'Limkokwing Book', value: 'Limkokwing Book' },
  { label: 'Medical Insurance Processing', value: 'Medical Insurance Processing' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Registration Fees', value: 'Registration Fees' },
  { label: 'Repeat Charge', value: 'Repeat Charge' },
  { label: 'Repeat Modules', value: 'Repeat Modules' },
  { label: 'Resource Fees', value: 'Resource Fees' },
  { label: 'Smart Card', value: 'Smart Card' },
  { label: 'Transcripts', value: 'Transcripts' },
  { label: 'Tuition Fees', value: 'Tuition Fees' },
  { label: 'Visa Overstay', value: 'Visa Overstay' },
  { label: 'Visa Processing', value: 'Visa Processing' },
  { label: 'Visa Renewal', value: 'Visa Renewal' },
  { label: 'Visa special pass', value: 'Visa special pass' },
  { label: 'Witdrawal fee', value: 'Witdrawal fee' },
];

export const statusList = [
  { label: 'All', value: '' },
  { label: 'Absent', value: 'Absent' },
  { label: 'On Leave', value: 'On Leave' },
  { label: 'Half Day', value: 'Half Day' },
  { label: 'On Duty', value: 'On Duty' },
  { label: 'Rest Day', value: 'Rest Day' },
  { label: 'Holiday', value: 'Holiday' },
  { label: 'Late Clock In', value: 'Late Clock In' },
  { label: 'Early Clock Out', value: 'Early Clock Out' },
  { label: 'Replacement Leave', value: 'Replacement Leave' },
  { label: 'Late Clock Out', value: 'Late Clock Out' },
];

export const contractType = [
  { label: 'All', value: '' },
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Probation', value: 'Probation' },
];

export const etypeList = [
  { label: 'Full-time', value: 'Full-time' },
  { label: 'Part-time', value: 'Part-time' },
];

export const ctypeList = [
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Probation', value: 'Probation' },
];
export const ctypeListLeave = [
  { label: 'All', value: 'All' },
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Probation', value: 'Probation' },
];
export const staffCategory = [
  { label: 'Non-Academic', value: 'Non-Academic' },
  { label: 'Academic', value: 'Academic' },
];

export const identificationList = [
  { label: 'IC', value: 'IC ' },
  { label: 'Passport', value: 'Passport ' },
];

export const degreeList = [
  { label: 'Foundation', value: 'Foundation' },
  { label: 'Diploma', value: 'Diploma' },
  { label: 'Degree', value: 'Degree' },
  { label: 'Masters Degree', value: 'Masters Degree' },
  { label: 'Doctorate', value: 'Doctorate' },
];
export const positionList = [
  { label: 'Junior Executive', value: 'Junior Executive' },
  { label: 'Senior Executive', value: 'Senior Executive' },
  { label: 'Assistant Manager', value: 'Assistant Manager' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Senior Manager', value: 'Senior Manager' },
  { label: 'Junior Partner', value: 'Junior Partner' },
  { label: 'Senior Partner', value: 'Senior Partner' },
  { label: 'Associate', value: 'Associate' },
  { label: 'Senior Associate', value: 'Senior Associate' },
  { label: 'Director', value: 'Director' },
  { label: 'Senior Director', value: 'Senior Director' },
];
export const relationList = [
  { label: 'Father', value: 'Father' },
  { label: 'Mother', value: 'Mother' },
  { label: 'Relative', value: 'Relative' },
  { label: 'Others', value: 'Others' },
];

export const timelap = [
  { label: 'am', value: 'am' },
  { label: 'pm', value: 'pm' },
];

export const workType = [
  { label: 'Full Day', value: 'Full Day' },
  { label: 'Half Day', value: 'Half Day' },
  { label: 'Rest Day', value: 'Rest Day' },
];

export const availabilityType = [
  { label: 'Available', value: 'Available' },
  { label: 'Unavailable', value: 'Unavailable' },
];

export const alternateSat = [
  { label: 'A (Week 1 and 3 of every month)', value: 'A (Week 1 and 3 of every month)' },
  { label: 'B (Week 2 and 4 of every month)', value: 'B (Week 2 and 4 of every month)' },
];

export const pStatus = [
  { label: 'Expiring', value: 'Expiring' },
  { label: 'Expired', value: 'Expired' },
  // { label: 'Active', value: 'Active' },
];

export const bloodList = [
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A-' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B-' },
  { label: 'O-', value: 'O-' },
  { label: 'O+', value: 'O+' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB-' },
];

export const documentation = [
  {
    title: 'STUDENT INFORMATION',
    docs: [
      { title: 'Student File', docname: 'Student File' },
      { title: 'Student Profile', docname: 'Student Profile' },
      { title: 'Application Form', docname: 'Application Form' },
      // {title: 'Passport Photo with White Background', docname: 'Passport Photo with White Background'},
      // {title: '6 Passport Size photograph with blue background (3.5cmx5cm)', docname: '6 Passport Size photograph with blue background (3.5cmx5cm)'},
      // {title: 'IC/Passport (Scanned)', docname: 'IC/Passport (Scanned)'},
      { title: 'Offer Letter', docname: 'Offer Letter' },
      { title: 'Acceptance of Offer Letter', docname: 'Acceptance of Offer Letter' },
      { title: 'Scholarship Letter', docname: 'Scholarship Letter' },
      // {title: 'Scholarship Letter from Sponsor',docname: 'Scholarship Letter from Sponsor'},
      { title: 'Tuition Fee Receipt', docname: 'Tuition Fee Receipt' },
      { title: 'Programme Approval Letter (KPT & MQA)', docname: 'Programme Approval Letter (KPT & MQA)' },
      { title: 'Financial Evidence', docname: 'Financial Evidence' },
      // {title: 'Financial Statement (Bank Statement', docname: 'Financial Statement (Bank Statement'},
    ],
  },
  {
    title: 'PASSPORT & STUDENT PASS INFORMATION',
    docs: [
      // {title: '2 Passport Copies including all blank pages', docname: '2 Passport Copies including all blank pages'},
      { title: 'Passport Page with Certified Copy', docname: 'Passport Pages with certified true copy' },
      { title: 'IM14 Form', docname: 'IM14 Form' },
      { title: 'Visa Approval Letter (VAL)', docname: 'Visa Approval Letter (VAL)' },
      { title: 'Personal Bond', docname: 'Personal Bond' },
      { title: 'Visa Sticker Endorsement Receipt', docname: 'Visa Sticker Endorsement Receipt' },
      { title: 'Visa Sticker', docname: 'Visa Sticker' },
      { title: 'IM55 Form', docname: 'IM55 Form' },
      // { title: 'Email Reminder (if any)', docname: 'Email Reminder' },
      // { title: 'Cancellation Documents (if any)', docname: 'Cancellation Documents (if any)' },
      // { title: '- Police Report', docname: 'Police Report', noindex: true },
      // { title: '- JIM Cancellation', docname: 'JIM Cancellation', noindex: true },
      // { title: '- JIM Tracking', docname: 'JIM Tracking', noindex: true },
      // { title: '- Embassy Email', docname: 'Embassy Email', noindex: true },
      // { title: '- Communication Reach', docname: 'Communication Reach', noindex: true },
    ],
  },
  {
    title: 'Cancellation Documents (if any)',
    docs: [
      { title: 'Clearance form', docname: 'Clearance form' },
      { title: 'Check out memo', docname: 'Check out memo' },
      { title: 'Exit stamp', docname: 'Exit stamp' },
      { title: 'Police Report', docname: 'Police Report' },
      { title: 'JIM Cancellation', docname: 'JIM Cancellation' },
      { title: 'JIM Tracking', docname: 'JIM Tracking' },
      { title: 'Embassy Email', docname: 'Embassy Email' },
      { title: 'Communication Reach', docname: 'Communication Reach' },
    ],
  },
  {
    title: 'ACADEMIC INFORMATION',
    docs: [
      { title: 'Academic Calendar', docname: 'Academic Calendar' },
      { title: 'Attendance Report (Every Semester)', docname: 'Attendance' },
      { title: 'Class Time Table', docname: 'Class Time Table' },
      { title: 'Academic Transcript (Every Semester)', docname: 'Academic Transcript' },
      { title: 'Course Advising Form (Every Semester)', docname: 'Course Advising Form' },
      { title: 'Academic Qualification', docname: 'Academic Qualification' },
      { title: 'Completion Letter', docname: 'Completion Letter' },
      { title: 'Official Academic Transcript', docname: 'Official Academic Transcript' },
      { title: 'Certificate', docname: 'Certificate' },
      { title: 'Academic Appeal (if any)', docname: 'Academic Appeal' },
      { title: 'Deferment Form (if any)', docname: 'Deferment Form' },
      { title: 'Termination Letter (if any)', docname: 'Termination Letter' },
      // {title: 'Student Consent for Progression', docname: 'Student Consent for Progression'},
      // {title: 'Certified copies of High School result (original & translated)', docname: 'Certified copies of High School result (original & translated)'},
      // {title: 'CertifiedCertified true copy of Higher Education result & certificate (original & translated)', docname: 'CertifiedCertified true copy of Higher Education result & certificate (original & translated)'},
      // {title: 'Proof of English Language Proficiency (IELTS/TOEFL)', docname: 'Proof of English Language Proficiency (IELTS/TOEFL)'},
    ],
  },
  {
    title: 'MEDICAL REPORT AND INSURANCE',
    docs: [
      { title: 'Copy of Insurance Policy', docname: 'Copy of Insurance Policy' },
      // {title: 'Copy of Insurance Cover Note/Medical Card', docname: 'Copy of Insurance Cover Note/Medical Card'},
      // {title: 'Medical Check-up', docname: 'Medical Check-up'},
      { title: 'Pre Medical Report', docname: 'Pre Medical Report' },
    ],
  },
  {
    title: 'OTHERS',
    docs: [
      { title: 'Release Letter (if any)', docname: 'Release Letter' },
      { title: 'Orientation Program', docname: 'Orientation Program' },
      {
        title: 'Personal Data Protection Acts (PDPA) - Acceptance',
        docname: 'Personal Data Protection Acts (PDPA) - Acceptance',
      },
      { title: 'Student Manual Book & Refund Policy', docname: 'Student Manual Book & Refund Policy' },
      { title: 'Warning Letter', docname: 'Warning Letter' },
      { title: 'Barred Letter', docname: 'Barred Letter' },
      {
        title: 'Leave Application (Medical certificate/ Emergency and etc)',
        docname: 'Leave Application (Medical certificate/ Emergency and etc)',
      },
      { title: 'Student Counselling Report', docname: 'Student Counselling Report' },
      // {title: 'Affidavit Letter', docname: 'Affidavit Letter'},
      // {title: 'CV', docname: 'CV'},
      // {title: 'Undertaking Letter', docname: 'Undertaking Letter'},
      // {title: 'Portfolio', docname: 'Portfolio'},
      // {title: 'Other related documents', docname: 'Other related documents'},
    ],
  },
];

// export const socket = socketIOClient('https://devcomm.limkokwing.net/', {
//   extraHeaders: {
//     authorization: token,
//     user_id: id,
//     user_type: 'lecturer',
//   },
// });

export const socket = {};

export const nonSalesFilters = [{
  label: "Non Sales: All",
  value: ""
}, {
  label: "Non Sales: No",
  value: "0"
}, {
  label: "Non Sales: Yes",
  value: "1"
}];

export const tenderFilters = [{
  label: "Tender Synced: All",
  value: ""
}, {
  label: "Tender Synced: No",
  value: "0"
}, {
  label: "Tender Synced: Yes",
  value: "1"
}];

export const cogsFilters = [{
  label: "COGS Synced: All",
  value: ""
}, {
  label: "COGS Synced: No",
  value: "0"
}, {
  label: "COGS Synced: Yes",
  value: "1"
}];

export const netsuiteFilters = [{
  label: "Netsuite Synced: All",
  value: ""
}, {
  label: "Netsuite Synced: No",
  value: "0"
}, {
  label: "Netsuite Synced: Yes",
  value: "1"
}];

export const isAdjustmentFilters = [{
  label: "Is Adjustment: All",
  value: ""
}, {
  label: "Is Adjustment: No",
  value: "0"
}, {
  label: "Is Adjustment: Yes",
  value: "1"
}];

export const isFaFilters = [{
  label: "Is FA: All",
  value: ""
}, {
  label: "Is FA: No",
  value: "0"
}, {
  label: "Is FA: Yes",
  value: "1"
}];